<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 18.0751 18.5751 23 12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1ZM12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3ZM13.625 15.6855C14.1771 15.6858 14.625 16.1334 14.625 16.6855C14.625 17.2377 14.1771 17.6853 13.625 17.6855H11.375C10.8227 17.6855 10.375 17.2378 10.375 16.6855C10.375 16.1333 10.8227 15.6855 11.375 15.6855H13.625ZM7.5 9C8.32843 9 9 9.67157 9 10.5C9 11.3284 8.32843 12 7.5 12C6.67157 12 6 11.3284 6 10.5C6 9.67157 6.67157 9 7.5 9ZM17.5 9C18.3284 9 19 9.67157 19 10.5C19 11.3284 18.3284 12 17.5 12C16.6716 12 16 11.3284 16 10.5C16 9.67157 16.6716 9 17.5 9Z"
      fill="currentColor"
    />
  </svg>
</template>
